import { render } from "./ImpuSum.vue?vue&type=template&id=297fb146"
import script from "./ImpuSum.vue?vue&type=script&lang=js"
export * from "./ImpuSum.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__